import React from "react"
import {NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './styles/Navbarcustom.css'


const Navbarcustom = () => {

    const { t, i18n } = useTranslation()

    const changeLanguage = (event) => {
      i18n.changeLanguage(event.target.value)
    }

    function handleCollapse (){
        var nav = document.getElementById("navbarSupportedContent");
        var btn = document.getElementById("btntoggler");
        nav.classList.remove("show");
        btn.classList.add("collapsed");
      };

    const divStyle = {
        display: 'flex',
        alignItems: 'center'
      };

    return(
        <>
        <div className="container-fluid nav-bg navbar-font" >
            <div className="col-12 mx-auto">
                            <div className="row navbar-div-language-selection" onChange={changeLanguage} >
                                <div style={divStyle} >
                                    <input type="radio" value="ta-IN" name="language" defaultChecked />&nbsp; தமிழ்   &nbsp;&nbsp;&nbsp;&nbsp;
                                    <input type="radio" value="en" name="language"/>&nbsp; English
                                </div>
                            </div>
            </div>

            <div className="row">
                    <div className="col-12 mx-auto">
                            <div className="row">
                                <div className="col-12 mx-auto">
                                    <nav className="navbar navbar-expand-lg navbar-light navbar-div-content">
                                    <a className="navbar-brand" href="/">{t('menu.title')}</a>
                                    
                                        <button id="btntoggler" className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                            <span className="navbar-toggler-icon"></span>
                                        </button>
                                    
                                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                            <ul className="navbar-nav ml-auto">
                                                <li className="nav-item " >
                                                    <NavLink activeClassName="menu-active" exact className="nav-link" aria-current="page" to="/" onClick={handleCollapse} >{t('menu.home')}  </NavLink>
                                                </li>
                                                <li className="nav-item " >
                                                    <NavLink activeClassName="menu-active" className="nav-link" to="/about" onClick={handleCollapse}>{t('menu.about')}</NavLink>
                                                </li>
                                                   
                                                <li className="nav-item " >
                                                    <NavLink activeClassName="menu-active" className="nav-link" to="/ministries" onClick={handleCollapse}>{t('menu.ministries')}</NavLink>
                                                </li>
                                                <li className="nav-item " >
                                                    <NavLink activeClassName="menu-active" className="nav-link" to="/gallery" onClick={handleCollapse}>{t('menu.gallery')}</NavLink> 
                                                </li>
                                                <li className="nav-item " >
                                                    <NavLink activeClassName="menu-active" className="nav-link" to="/contact" onClick={handleCollapse}>{t('menu.contact')}</NavLink>
                                                </li>
                                                <li className="nav-item " >
                                                    <NavLink activeClassName="menu-active" className="nav-link" to="/committee" onClick={handleCollapse}>{t('menu.committee')}</NavLink>
                                                </li>
                                                {
                                                }
                                            </ul>
                                        </div>
                                    </nav>
                                </div>
                        </div>
                    </div>
            </div>


        </div>
        </>
    );
}

export default Navbarcustom 